import { StateDropDown } from '@apply/components';
import { useCustomPaymentAddressState } from '../../../../../fields/CustomPaymentFields';
import { isMobileScreen } from '@apply/ui';

interface StateProps {
    customPaymentId: string;
    required?: boolean;
    validator?: React.ReactNode;
}

export const State: React.FC<StateProps> = ({ customPaymentId, required = false, validator }) => {
    const mobileScreen = isMobileScreen();
    const label = 'State';
    const [state, set_state] = useCustomPaymentAddressState(customPaymentId);

    return (
        <>
            <StateDropDown
                id='customPaymentState'
                value={state}
                onChange={(value) => set_state(value)}
                label={label}
                required={required}
                width={mobileScreen ? '100%' : '220px'}
                validator={validator}
            />
        </>
    );
};
